import {
  FaCodeBranch,
  FaJava,
  FaAppStore,
  FaNode,
  FaAws,
  FaDatabase,
} from 'react-icons/fa';
import { DiMongodb, DiGit } from 'react-icons/di';
import { AiOutlineApi } from 'react-icons/ai';
import {
  IoLogoJavascript,
  IoLogoPython,
  IoLogoHtml5,
  IoLogoCss3,
} from 'react-icons/io';
import {
  SiC,
  SiCsharp,
  SiCplusplus,
  SiApachekafka,
  SiGo,
  SiSwift,
  SiReact,
  SiSpring,
  SiExpress,
  SiGraphql,
  SiHibernate,
  SiSequelize,
  SiMongoose,
  SiSass,
  SiTensorflow,
  SiUnity,
  SiUnrealengine,
  SiGooglecloud,
  SiGithub,
  SiJenkins,
  SiAnsible,
  SiTerraform,
  SiKubernetes,
  SiDocker,
  SiIstio,
  SiFigma,
  SiApachemaven,
  SiBlender,
  SiSonarqube,
  SiSplunk,
  SiJira,
  SiFluentd,
  SiPrometheus,
  SiGrafana,
  SiKibana,
  SiXcode,
  SiOracle,
  SiPostgresql,
  SiMysql,
  SiSqlite,
  SiElasticsearch,
  SiHcl,
  SiYaml,
  SiTypescript,
  SiExpo,
  SiFirebase,
  SiNpm,
  SiPacker,
  SiFlyway,
  SiJest,
  SiRtl,
  SiJunit5,
  SiSolidity,
} from 'react-icons/si';
import { BsFiletypeJson, BsFiletypeXml } from 'react-icons/bs';

export const NEULogo = require('../assets/images/NEULogo.png');
export const AnnaLogo = require('../assets/images/AnnaLogo.png');
export const InfosysLogo = require('../assets/images/InfosysLogo.png');
export const DiallLogo = require('../assets/images/DiallLogo.png');
export const githubIcon = require('../assets/images/githubIcon.png');
export const linkedinIcon = require('../assets/images/linkedinIcon.png');
export const youtubeIcon = require('../assets/images/youtubeIcon.png');
export const instagramIcon = require('../assets/images/instagramIcon.png');
export const myPhoto = require('../assets/images/myPhoto.jpeg');
export const sofa = require('../assets/images/sofa.png');

export const portfolioWebsiteUrl = 'https://vigneshgvs.github.io/';
export const myEmailId = 'gunasekaran.v@northeastern.edu';
export const myLinkedInURL = 'https://www.linkedin.com/in/vig-gunasekaran/';
export const myGitHubURL = 'https://github.com/Vigneshgvs';
export const myYoutubeURL =
  'https://www.youtube.com/channel/UCKvicnnYtc5aRH8qZChZLwQ';
export const myInstagramURL = 'https://www.instagram.com/vigneshgunasekaran/';
export const myLocation = `Boston, MA`;
export const myName = 'Vignesh Gunasekaran';
// export const myResume = '../assets/VigneshGunasekaran.pdf';
export const myResume = '/Vignesh_Gunasekaran_resume.pdf';
export const myResumeName = 'Vignesh_Gunasekaran_resume.pdf';
export const diallAppStoreLink =
  'https://apps.apple.com/us/app/diall-ask-a-therapist/id6446042096';
export const diallUrl = 'https://www.diallapp.com/';
export const infosysUrl = 'https://www.infosys.com/';

export const homeTextColor = 'white'; //black #d1cfcb
export const homeTextButtonColor = 'black';

export const skillColor = '#007396';
// export const skillColor = '#3da6ff';
export const buttonColor = '#3da6ff';
export const courseColor = 'lightblue';
// export const myBG = '#eaeded';
export const myBG = '#88898a';

// function getProjectDetails(projectName) {
//   const project = projectsData.find((project) => project.title === projectName);

//   if (project) {
//     return {
//       projectTitle: project.title,
//       projectDescription: project.description,
//       projectLink: project.link,
//       projectDemo: project.demo,
//     };
//   }

//   // Return default values if project details are not found
//   return {
//     projectTitle: '',
//     projectDescription: '',
//     projectLink: '',
//     projectDemo: '',
//   };
// }

export const filterProjectsByCourseName = (courseName) => {
  return projectsData.filter((project) => project.courseName === courseName);
};
/* beauty of JS
If no courseName is matched, the output of filterProjectsByCourseName will be an empty array ([]).
If only one courseName is matched, the output will be an array with one JSON object representing the matched
 project. So the output will be an array with a single element, like [project].
*/

export const experiencesData = [
  {
    role: 'iOS Engineer Intern',
    employer: 'Diall INC',
    logo: DiallLogo,
    logoUrl: diallUrl,
    logoWidth: 20,
    logoHeight: 20,
    city: 'Remote, Boston',
    duration: 'Jan 2023 - Apr 2023',
    skills:
      'React Native, Firebase, Expo, AWS, React.js, React Hooks, Node.js, Express.js, HTML, CSS, JavaScript',
    description: [
      'Developed an iOS app, ‘Diall - Ask a Therapist’, using React Native facilitating video-based interactions between users and licensed therapists for mental health discussions.',
      'Engineered diverse features in the app, ensuring intuitive functionality and cross-platform compatibility.',
      'Designed and implemented a user-friendly social media interface that enables seamless browsing of user-generated video feeds.',

      <div>
        <text>iOS App Store Link: </text>
        <b>
          <a href={diallAppStoreLink} target='_blank' rel='noopener noreferrer'>
            Diall - Ask a Therapist
          </a>
        </b>
      </div>,
    ],
  },
  {
    role: 'Technology Analyst',
    employer: 'Infosys Limited',
    logo: InfosysLogo,
    logoUrl: infosysUrl,
    logoWidth: 40,
    logoHeight: 20,
    city: 'Hybrid',
    duration: 'Apr 2020 - Aug 2021',
    skills: 'Java, Spring MVC, Spring Boot, REST API, SQL, Hibernate, JUnit',
    description: [
      'Developed backend Java RESTful APIs for seamless capture, upload, and deposit functionalities in the bank’s Check Services domain.',
      'Led the deployments of the application into production environments, earning recognition as a standout member of the team.',
      'Took a leadership role in scrum ceremonies like Sprint Planning, Daily Scrum, Sprint Review & Retrospective, Backlog Refinement.',
      'Client: Bank of America',
    ],
  },
  {
    role: 'Senior Software Engineer',
    employer: 'Infosys Limited',
    logo: InfosysLogo,
    logoUrl: infosysUrl,
    logoWidth: 40,
    logoHeight: 20,
    city: 'Chennai, India',
    duration: 'Aug 2017 - Apr 2020',
    skills: 'C, Java, Spring MVC, Spring Boot, REST API, SQL, Hibernate, JUnit',
    description: [
      'Developed the employee upskilling microservice in Java Spring Boot, with zero defects & boosted client satisfaction.',
      'Conducted code reviews and strategized on improving code quality and delivery speed by unit test coverage & code practices.',
      'Addressed technical debt by migrating legacy C code to the Java platform, collaborating with an agile team of 15, adhering to SDLC.',
      'Clients: AT&T, Verizon',
    ],
  },
  {
    role: 'Software Engineer',
    employer: 'Infosys Limited',
    logo: InfosysLogo,
    logoUrl: infosysUrl,
    logoWidth: 40,
    logoHeight: 20,
    city: 'Mysuru & Chennai, India',
    duration: 'Dec 2015 - Aug 2017',
    skills:
      'Java, Spring MVC, REST API, SQL, HTML, CSS, JavaScript, Ajax, jQuery, ATG, JUnit, Selenium',
    description: [
      'Debugged and resolved application defects per SLA standards while maintaining a strong defect-resolving score for the project.',
      'Resolved the highest number of critical production defects within the team, leading to certification opportunities.',
      'Client: AT&T',
    ],
  },
];

export const filterOptions = [
  'All',
  'Web Dev',
  'App Dev',
  'Front end',
  'Back end',
  'Cloud',
  'Database',
  'Game Dev',
  'AI',
];

export const projectsData = [
  {
    id: 3,
    title: 'NEU First Response',
    tech: 'Java, Swing, db4o, Spring Boot',
    description:
      'Developed an emergency management system to offer prevention, handling, and documentation of incidents for university members.',
    link: '',
    demo: '',
    courseName: 'Application & Engineering Development',
    category: ['Back end', 'Database'],
  },
  {
    id: 2,
    title: 'NEU Tweet',
    tech: 'React.js, Figma, HTML5, CSS3, Sass, JavaScript ES6, NodeJS, React Router, Redux, REST API, Mongoose, MongoDB, JSON, Jest, RTL',
    description:
      'Developed a Twitter-like React web application in MERN stack for university members to tweet their views & assist in networking.',
    link: '',
    demo: 'https://www.youtube.com/embed/L8-HsmSDIP8',
    courseName: 'Web Design & User Experience Engineering',
    category: ['Web Development', 'Front end', 'Back end', 'Database'],
  },
  {
    id: 4,
    title: 'Husky Profile',
    description:
      'Employing AWS resources, CloudFormation orchestrated infrastructure of Node.js backend microservices, encompassing VPC, scalable EC2 instances, IAM, Route53, EBS, & CodeDeploy. Secure S3 storage managed profile pictures; RDS stored other profile details. DynamoDB, with TTL, handled one-time-use tokens. SNS triggered Lambda functions to send time-sensitive verification emails via SES. CloudWatch logged data & monitored metrics. Used GitHub Actions for streamlined CI/CD pipelines.',
    tech: 'AWS - CloudFormation, VPC, EC2, IAM, Route53, S3, CloudWatch, CodeDeploy, RDS, DynamoDB, Lambda –Serverless, SNS, SES, KMS; JavaScript, node.js, Express.js, REST API, Sequelize, MySQL, GitHub Actions, Packer, Linux',
    link: '',
    demo: '',
    courseName: 'Network Structures & Cloud Computing',
    category: ['Cloud', 'Back end', 'Database'],
  },
  {
    id: 5,
    title: 'Distributed To-Do',
    description:
      'Engineered HA Kubernetes clusters on AWS using Terraform, enabling containerization of Dockerized to-do and Kafka consumer microservices managed by Helm Charts. Implemented Flyway for database migrations, orchestrated communication with Istio enhancing architecture, logged with the EFK stack, monitored metrics using Prometheus, & automated processes using Jenkins.',
    tech: 'AWS, Terraform, Kubernetes, Docker, Jenkins, Java, SpringBoot, Hibernate, Flyway, kOps, Elasticsearch, Fluentd, Kibana, Kafka, Prometheus, Grafana, Istio, kubectl, Packer',
    link: '',
    demo: '',
    courseName: 'Advanced Cloud Computing',
    category: ['Cloud', 'Back end', 'Database'],
  },
  {
    id: 1,
    title: 'ConNect iOS App',
    description:
      'Developed an iOS app that facilitates real-time connections to nearby individuals’ social handles.',
    tech: 'iOS, Swift, Xcode, UIKit, Storyboard, Core Data, Java, Spring Boot, MySQL, Xcode',
    link: '',
    demo: 'https://www.youtube.com/embed/U_InIS3ql7A',
    courseName: 'Smartphones-based Web Development',
    category: ['App Development', 'Front end', 'Back end', 'Database'],
  },
  {
    id: 7,
    title: 'Application of Machine Learning in Image Caption Generation',
    description:
      'Generated captions for images in the Flickr 8k dataset, using CNN + LSTM and ResNet + GRU approaches and compared their results.',
    tech: 'Python, TensorFlow, Scikit-learn, NumPy, Pandas',
    link: '',
    demo: '',
    courseName: 'Data Science Engineering Methods & Tools',
    category: ['Artificial Intelligence AI'],
  },
  {
    id: 6,
    title: 'Hawaii Island',
    description:
      'Developed an ‘Adventure Island’-like game and incorporated various Shaders, Materials, Particle Effects, Animations, and AI elements',
    tech: 'Unity 3D, C#',
    link: '',
    demo: 'https://www.youtube.com/embed/i3tFMAetlBw',
    courseName: 'Building Virtual Environments',
    category: ['Game Development', 'Front end', 'Back end', 'Database'],
  },
  {
    id: 8,
    title: 'Portfolio',
    description:
      'Developed this portfolio website using React JS and Create React App. Replicated the navigation bar of Apple.com, incorporated the famous buttons of Amazon.com, and styled the Tech Skills section with inspiration from Apple’s WWDC presentation-slide design. Implemented form submission in the Contact section using FormCarry’s React hook.',
    tech: 'React JS, React Hooks, HTML, CSS, JavaScript',
    link: '',
    demo: '',
    courseName: '',
    category: ['Front end', 'Web Development'],
  },
  // {
  //   id: 0,
  //   title: 'iOS Engineer - Internship @ Diall',
  //   description:
  //     'Developed an iOS app, ‘Diall - Ask a Therapist’, using React Native facilitating video-based interactions between users and licensed therapists for mental health discussions, ensuring intuitive functionality and cross-platform compatibility. Designed and implemented a user-friendly social media interface that enables seamless browsing of user-generated video feeds.',
  //   tech: 'React Native, Firebase, Expo, AWS, React.js, React Hooks, Node.js, Express.js, HTML, CSS, JavaScript',
  //   link: '',
  //   specialLink: diallAppStoreLink,
  //   demo: '',
  //   courseName: '',
  //   category: ['Front end', 'App Development'],
  // },
];

export const educationData = [
  {
    id: 1,
    logo: NEULogo,
    institution: 'Northeastern University',
    college: 'College of Engineering',
    degree: 'Master of Science',
    field: 'Information Systems',
    duration: 'Sep 2021 - Dec 2023',
    educationType: 'graduate',
  },
  {
    id: 2,
    logo: AnnaLogo,
    institution: 'Anna University',
    college: 'Loyola ICAM College of Engineering and Technology',
    degree: 'Bachelor of Engineering',
    field: 'Computer Science and Engineering',
    duration: 'Aug 2011 - May 2015',
    educationType: 'undergraduate',
  },
];

export const graduateCoursesData = [
  {
    courseName: 'Application & Engineering Development',
    techSkills: 'Java, Swing, db4o, Spring Boot',
  },
  {
    courseName: 'Web Design & User Experience Engineering',
    techSkills:
      'React.js, Figma, HTML5, CSS3, Sass, JavaScript ES6, NodeJS, React Hooks, React Router, Redux, REST API, Mongoose, MongoDB, JSON, Jest, RTL',
  },
  {
    courseName: 'Network Structures & Cloud Computing',
    techSkills:
      'AWS - CloudFormation, VPC, EC2, IAM, Route53, S3, SES, CloudWatch, CodeDeploy, RDS, DynamoDB, Lambda, SNS, KMS and JavaScript, node.js, Express.js, REST API, Sequelize, MySQL, GitHub Actions, Packer, Linux',
  },
  {
    courseName: 'Advanced Cloud Computing',
    techSkills:
      'AWS, Terraform, Kubernetes, Docker, Jenkins, Java, SpringBoot, Hibernate, Flyway, Kops, Elasticsearch, Fluentd, Kibana, Kafka, Prometheus, Grafana, Istio, kubectl, Packer',
  },
  {
    courseName: 'Smartphones-based Web Development',
    techSkills:
      'iOS, Swift, Xcode, Cocoa Touch, UIKit, Storyboard, SwiftUI, Core Data, User Defaults',
  },
  {
    courseName: 'Data Science Engineering Methods & Tools',
    techSkills: 'Python, TensorFlow, Scikit-learn, NumPy, Pandas',
  },
  {
    courseName: 'Building Virtual Environments',
    techSkills: 'Unity 3D, C#, Unreal Engine, C++',
  },
  {
    courseName: 'Cryptocurrency and Smart Contract Engineering',
    techSkills: 'Cryptography, Bitcoin, Ethereum, Solidity, Foundry, Web3',
  },
  {
    courseName: 'Data Structures and Algorithms',
    techSkills: 'Java Programming in Data Structures, Algorithms',
  },
];

export const undergraduateCoursesData = [
  {
    courseName: 'Programming Paradigm',
    techSkills: 'Core Java',
  },
  {
    courseName: 'Web Development',
    techSkills: 'HTML, CSS, Javascript',
  },
  {
    courseName: 'Data Structures',
    techSkills: 'Java - Stack, List, Queue, Heap, Map, etc...',
  },
  {
    courseName: 'Database Management System',
    techSkills: 'SQL, PL/SQL',
  },
  {
    courseName: 'Operating Systems',
    techSkills: 'OS core concepts',
  },
  {
    courseName: 'Network Structures',
    techSkills: 'Networks core concepts',
  },
  {
    courseName: 'Theory of Computation',
    techSkills: 'Computational skills',
  },
];

// export const TechArea = [
//   {
//     name: 'Java',
//     type: 'Programming/Configuration Languages',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'C',
//     type: 'Programming/Configuration Languages',
//     category: ['other'],
//   },
//   {
//     name: 'C++',
//     type: 'Programming/Configuration Languages',
//     category: ['Game Dev', 'other'],
//   },
//   {
//     name: 'JavaScript',
//     type: 'Programming/Configuration Languages',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'HTML',
//     type: 'Programming/Configuration Languages',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'CSS',
//     type: 'Programming/Configuration Languages',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'C#',
//     type: 'Programming/Configuration Languages',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'SQL',
//     type: 'Programming/Configuration Languages',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Python',
//     type: 'Programming/Configuration Languages',
//     category: ['AI', 'other'],
//   },
//   {
//     name: 'Go',
//     type: 'Programming/Configuration Languages',
//     category: ['cloud'],
//   },
//   {
//     name: 'Swift',
//     type: 'Programming/Configuration Languages',
//     category: ['App Dev'],
//   },
//   {
//     name: 'React',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Spring MVC',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Spring Boot',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'ExpressJS',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'REST',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'GraphQL',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Hibernate',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Sequelize',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Mongoose',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Sass',
//     type: 'Frameworks/Libs',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'TensorFlow',
//     type: 'Frameworks/Libs',
//     category: ['AI'],
//   },
//   {
//     name: 'Unity',
//     type: 'Frameworks/Libs',
//     category: ['Game Dev'],
//   },
//   {
//     name: 'Unreal Engine',
//     type: 'Frameworks/Libs',
//     category: ['Game Dev'],
//   },
//   {
//     name: 'Cocoa Touch',
//     type: 'Frameworks/Libs',
//     category: ['App Dev'],
//   },
//   {
//     name: 'UIKit',
//     type: 'Frameworks/Libs',
//     category: ['App Dev'],
//   },
//   {
//     name: 'SwiftUI',
//     type: 'Frameworks/Libs',
//     category: ['App Dev'],
//   },
//   {
//     name: 'Kafka',
//     type: 'Frameworks/Libs',
//     category: ['cloud'],
//   },
//   {
//     name: 'AWS',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'GCP',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'Node.js',
//     type: 'DevOps',
//     category: ['cloud', 'other'],
//   },
//   {
//     name: 'CI/CD- GitHub',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'Jenkins',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'IAC- Ansible',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'Terraform',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'CloudFormation',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'Kubernetes',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'Docker',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'Istio',
//     type: 'DevOps',
//     category: ['cloud'],
//   },
//   {
//     name: 'Figma',
//     type: 'Tools',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Maven',
//     type: 'Tools',
//     category: ['other'],
//   },
//   {
//     name: 'Packer',
//     type: 'Tools',
//     category: ['cloud'],
//   },
//   {
//     name: 'Blender',
//     type: 'Tools',
//     category: ['Game Dev'],
//   },
//   {
//     name: 'Git',
//     type: 'Tools',
//     category: ['other'],
//   },
//   {
//     name: 'SVN',
//     type: 'Tools',
//     category: ['other'],
//   },
//   {
//     name: 'SonarQube',
//     type: 'Tools',
//     category: ['other'],
//   },
//   {
//     name: 'Splunk',
//     type: 'Tools',
//     category: ['other'],
//   },
//   {
//     name: 'Jira',
//     type: 'Tools',
//     category: ['other'],
//   },
//   {
//     name: 'Fluentd',
//     type: 'Tools',
//     category: ['cloud'],
//   },
//   {
//     name: 'Prometheus',
//     type: 'Tools',
//     category: ['cloud'],
//   },
//   {
//     name: 'Grafana',
//     type: 'Tools',
//     category: ['cloud'],
//   },
//   {
//     name: 'Kibana',
//     type: 'Tools',
//     category: ['cloud'],
//   },
//   {
//     name: 'Xcode',
//     type: 'Tools',
//     category: ['App Dev'],
//   },
//   {
//     name: 'Oracle',
//     type: 'Databases',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'PostgreSQL',
//     type: 'Databases',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'MySQL',
//     type: 'Databases',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'SQLite',
//     type: 'Databases',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'NoSQL- MongoDB',
//     type: 'Databases',
//     category: ['Web Dev', 'App Dev'],
//   },
//   {
//     name: 'Elasticsearch',
//     type: 'Databases',
//     category: ['cloud'],
//   },
// ];

//section section id='tech-skills'
export const TechArea = [
  // Languages
  {
    name: 'Java',
    type: 'Programming/Configuration Languages',
    category: ['Back end'],
    iconName: FaJava,
    level: 3,
  },
  // {
  //   name: 'AWS',
  //   type: 'DevOps',
  //   category: ['Cloud'],
  //   iconName: FaAws,
  //   level: 3,
  // },
  {
    name: 'JavaScript',
    type: 'Programming/Configuration Languages',
    category: ['Web Dev', 'App Dev', 'Back end'],
    iconName: IoLogoJavascript,
    level: 3,
  },
  {
    name: 'TypeScript',
    type: 'Programming/Configuration Languages',
    category: ['Web Dev'],
    iconName: SiTypescript,
    level: 1,
  },

  {
    name: 'Python',
    type: 'Programming/Configuration Languages',
    category: ['AI'],
    iconName: IoLogoPython,
    level: 1,
  },

  {
    name: 'HTML',
    type: 'Programming/Configuration Languages',
    category: ['Web Dev', 'App Dev'],
    iconName: IoLogoHtml5,
    level: 3,
  },
  {
    name: 'CSS',
    type: 'Programming/Configuration Languages',
    category: ['Web Dev', 'App Dev'],
    iconName: IoLogoCss3,
    level: 3,
  },
  {
    name: 'SQL',
    type: 'Programming/Configuration Languages',
    category: ['Back end'],
    iconName: FaDatabase,
    level: 3,
  },
  {
    name: 'Swift',
    type: 'Programming/Configuration Languages',
    category: ['App Dev', 'Back end'],
    iconName: SiSwift,
    level: 3,
  },
  {
    name: 'C',
    type: 'Programming/Configuration Languages',
    category: ['Other'],
    iconName: SiC,
    level: 1,
  },
  {
    name: 'C++',
    type: 'Programming/Configuration Languages',
    category: ['Game Dev'],
    iconName: SiCplusplus,
    level: 1,
  },
  {
    name: 'C#',
    type: 'Programming/Configuration Languages',
    category: ['Game Dev'],
    iconName: SiCsharp,
    level: 1,
  },
  {
    name: 'Solidity',
    type: 'Programming/Configuration Languages',
    category: ['Back end'],
    iconName: SiSolidity,
    level: 1,
  },
  // {
  //   name: 'Go',
  //   type: 'Programming/Configuration Languages',
  //   category: ['Cloud'],
  //   iconName: SiGo,
  //   level: 1,
  // },
  {
    name: 'XML',
    type: 'Programming/Configuration Languages',
    category: ['Back end'],
    iconName: BsFiletypeXml,
    level: 1,
  },
  {
    name: 'JSON',
    type: 'Programming/Configuration Languages',
    category: ['Web Dev', 'App Dev', 'Back end'],
    iconName: BsFiletypeJson,
    level: 3,
  },
  {
    name: 'YAML',
    type: 'Programming/Configuration Languages',
    category: ['Cloud'],
    iconName: SiYaml,
    level: 3,
  },
  {
    name: 'HCL',
    type: 'Programming/Configuration Languages',
    category: ['Cloud'],
    iconName: SiHcl,
    level: 3,
  },

  // Frameworks
  {
    name: 'ReactJS',
    type: 'Frameworks/Libs',
    category: ['Web Dev'],
    iconName: SiReact,
    level: 3,
  },
  {
    name: 'ReactNative',
    type: 'Frameworks/Libs',
    category: ['App Dev'],
    iconName: SiReact,
    level: 3,
  },

  {
    name: 'SpringMVC',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiSpring,
    level: 3,
  },
  {
    name: 'SpringBoot',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiSpring,
    level: 3,
  },
  {
    name: 'ExpressJS',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiExpress,
    level: 3,
  },
  {
    name: 'REST',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: AiOutlineApi,
    level: 3,
  },
  {
    name: 'GraphQL',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiGraphql,
    level: 1,
  },
  {
    name: 'SwiftUI',
    type: 'Frameworks/Libs',
    category: ['App Dev'],
    iconName: SiSwift,
    level: 1,
  },
  // {
  //   name: 'Foundry',
  //   type: 'Frameworks/Libs',
  //   category: ['Back end'],
  //   iconName: SiSwift, //gotta change
  //   level: 1,
  // },
  {
    name: 'Unity',
    type: 'Frameworks/Libs',
    category: ['Game Dev'],
    iconName: SiUnity,
    level: 1,
  },
  {
    name: 'UnrealEngine',
    type: 'Frameworks/Libs',
    category: ['Game Dev'],
    iconName: SiUnrealengine,
    level: 1,
  },
  // {
  //   name: 'TensorFlow',
  //   type: 'Frameworks/Libs',
  //   category: ['AI'],
  //   iconName: SiTensorflow,
  //   level: 1,
  // },
  {
    name: 'UIKit',
    type: 'Frameworks/Libs',
    category: ['App Dev'],
    iconName: FaAppStore,
    level: 3,
  },
  {
    name: 'CocoaTouch',
    type: 'Frameworks/Libs',
    category: ['App Dev'],
    iconName: FaAppStore,
    level: 3,
  },
  {
    name: 'Expo',
    type: 'Frameworks/Libs',
    category: ['App Dev'],
    iconName: SiExpo,
    level: 3,
  },
  {
    name: 'Hibernate',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiHibernate,
    level: 3,
  },
  {
    name: 'Sequelize',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiSequelize,
    level: 3,
  },
  {
    name: 'Mongoose',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiMongoose,
    level: 3,
  },
  {
    name: 'Sass',
    type: 'Frameworks/Libs',
    category: ['Web Dev', 'App Dev'],
    iconName: SiSass,
    level: 3,
  },
  {
    name: 'Jest',
    type: 'Frameworks/Libs',
    category: ['Web Dev'],
    iconName: SiJest,
    level: 1,
  },
  {
    name: 'RTL',
    type: 'Frameworks/Libs',
    category: ['Web Dev'],
    iconName: SiRtl,
    level: 1,
  },
  {
    name: 'JUnit',
    type: 'Frameworks/Libs',
    category: ['Back end'],
    iconName: SiJunit5,
    level: 3,
  },
  //devops
  {
    name: 'AWS',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: FaAws,
    level: 3,
  },

  {
    name: 'Node.js',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: FaNode,
    level: 3,
  },
  {
    name: 'Kafka',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: SiApachekafka,
    level: 3,
  },
  {
    name: 'Jenkins',
    type: 'DevOps',
    category: ['Other'],
    iconName: SiJenkins,
    level: 3,
  },

  {
    name: 'Terraform',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: SiTerraform,
    level: 3,
  },
  {
    name: 'CloudFormation',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: FaAws,
    level: 3,
  },
  {
    name: 'Kubernetes',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: SiKubernetes,
    level: 3,
  },
  {
    name: 'Docker',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: SiDocker,
    level: 3,
  },
  {
    name: 'GitHub',
    type: 'DevOps',
    category: ['Other'],
    iconName: SiGithub,
    level: 3,
  },
  // {
  //   name: 'GCP',
  //   type: 'DevOps',
  //   category: ['Cloud'],
  //   iconName: SiGooglecloud,
  //   level: 1,
  // },
  {
    name: 'Ansible',
    type: 'DevOps',
    category: ['Other'],
    iconName: SiAnsible,
    level: 1,
  },
  {
    name: 'Istio',
    type: 'DevOps',
    category: ['Cloud'],
    iconName: SiIstio,
    level: 1,
  },
  // Tools
  {
    name: 'Figma',
    type: 'Tools',
    category: ['Web Dev', 'App Dev'],
    iconName: SiFigma,
    level: 1,
  },
  {
    name: 'Maven',
    type: 'Tools',
    category: ['Back end'],
    iconName: SiApachemaven,
    level: 3,
  },
  {
    name: 'npm',
    type: 'Tools',
    category: ['Web Dev', 'Back end'],
    iconName: SiNpm,
    level: 3,
  },
  {
    name: 'Blender',
    type: 'Tools',
    category: ['Game Dev'],
    iconName: SiBlender,
    level: 1,
  },
  {
    name: 'Git',
    type: 'Tools',
    category: ['Other'],
    iconName: DiGit,
    level: 3,
  },
  {
    name: 'SVN',
    type: 'Tools',
    category: ['Other'],
    iconName: FaCodeBranch,
    level: 3,
  },
  {
    name: 'SonarQube',
    type: 'Tools',
    category: ['Back end'],
    iconName: SiSonarqube,
    level: 3,
  },
  {
    name: 'Splunk',
    type: 'Tools',
    category: ['Other'],
    iconName: SiSplunk,
    level: 3,
  },
  {
    name: 'Jira',
    type: 'Tools',
    category: ['Other'],
    iconName: SiJira,
    level: 3,
  },
  {
    name: 'Packer',
    type: 'Tools',
    category: ['Cloud'],
    iconName: SiPacker,
    level: 1,
  },
  {
    name: 'Flyway',
    type: 'Tools',
    category: ['Cloud'],
    iconName: SiFlyway,
    level: 1,
  },
  {
    name: 'Fluentd',
    type: 'Tools',
    category: ['Cloud'],
    iconName: SiFluentd,
    level: 1,
  },
  {
    name: 'Prometheus',
    type: 'Tools',
    category: ['Cloud'],
    iconName: SiPrometheus,
    level: 1,
  },
  {
    name: 'Grafana',
    type: 'Tools',
    category: ['Cloud'],
    iconName: SiGrafana,
    level: 1,
  },

  {
    name: 'Kibana',
    type: 'Tools',
    category: ['Cloud'],
    iconName: SiKibana,
    level: 1,
  },
  {
    name: 'Xcode',
    type: 'Tools',
    category: ['App Dev'],
    iconName: SiXcode,
    level: 3,
  },
  {
    name: 'kubectl',
    type: 'Tools',
    category: ['Cloud'],
    iconName: SiKubernetes,
    level: 3,
  },
  {
    name: 'OracleSQL',
    type: 'Databases',
    category: ['Back end'],
    iconName: SiOracle,
    level: 3,
  },
  {
    name: 'PostgreSQL',
    type: 'Databases',
    category: ['Back end'],
    iconName: SiPostgresql,
    level: 3,
  },
  {
    name: 'MySQL',
    type: 'Databases',
    category: ['Back end'],
    iconName: SiMysql,
    level: 3,
  },
  {
    name: 'SQLite',
    type: 'Databases',
    category: ['Back end', 'App Dev'],
    iconName: SiSqlite,
    level: 1,
  },
  {
    name: 'RDS',
    type: 'Databases',
    category: ['Cloud'],
    iconName: FaAws,
    level: 1,
  },
  {
    name: 'MongoDB',
    type: 'Databases',
    category: ['Back end'],
    iconName: DiMongodb,
    level: 3,
  },
  {
    name: 'Elasticsearch',
    type: 'Databases',
    category: ['Cloud'],
    iconName: SiElasticsearch,
    level: 1,
  },
  {
    name: 'DynamoDB',
    type: 'Databases',
    category: ['Cloud'],
    iconName: FaAws,
    level: 1,
  },
  {
    name: 'Firebase',
    type: 'Databases',
    category: ['App Dev'],
    iconName: SiFirebase,
    level: 1,
  },
];
